import { Grid, Cell } from 'components/Grid';
import styles from './productsCardGrid.scss';
import { NO_ELEMENT, hasElements } from 'utils';
import {
  isDesktop as isDesktopSelector,
  isMobile as isMobileSelector,
  isTabletLayout as isTabletLayoutSelector
} from 'components/Shared/responsive';
import { ProductCard } from 'components/Shared/Product/themes/BGH/productCard';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import { useSelector } from 'react-redux';

const MOBILE_WIDTH = 181;
const DESKTOP_WIDTH = 282;
const IMAGE_MARGIN = 2;

const picture = {
  height: DESKTOP_WIDTH + IMAGE_MARGIN,
  width: DESKTOP_WIDTH + IMAGE_MARGIN
};

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

const AMOUNT_OF_PRODUCTS_MOBILE = 2;
const AMOUNT_OF_PRODUCTS_TABLET = 3;
const AMOUNT_OF_PRODUCTS_DESKTOP = 4;
const AMOUNT_OF_PRODUCTS_HUGE = 5;

const getAmountOfProducts = (
  isPhone: boolean,
  isTabletLayout: boolean,
  isDesktop: boolean
): number => {
  if (isPhone) {
    return AMOUNT_OF_PRODUCTS_MOBILE;
  }

  if (isTabletLayout) {
    return AMOUNT_OF_PRODUCTS_TABLET;
  }
  if (isDesktop) {
    return AMOUNT_OF_PRODUCTS_DESKTOP;
  }
  return AMOUNT_OF_PRODUCTS_HUGE;
};

type ProductsCardGridProps = {
  products: ProductlistViewProduct[];
  setElementRef?: (args: { ref: HTMLDivElement | null; payload: ProductlistViewProduct }) => void;
};

export const ProductsCardGrid = ({ products, setElementRef }: ProductsCardGridProps) => {
  const isPhone = useSelector(isMobileSelector);
  const isTabletLayout = useSelector(isTabletLayoutSelector);
  const isDesktop = useSelector(isDesktopSelector);

  if (!hasElements(products)) {
    return NO_ELEMENT;
  }

  const amountOfProducts = getAmountOfProducts(isPhone, isTabletLayout, isDesktop);

  const content = products
    .slice(0, amountOfProducts)
    .map((product: ProductlistViewProduct, index: number) => {
      const refProps = setElementRef
        ? { ref: (node: HTMLDivElement | null) => setElementRef({ ref: node, payload: product }) }
        : {};
      return (
        <Cell key={index} {...refProps}>
          <ProductCard isCategoryBold {...product} picture={picture} customSizes={sizes} />
        </Cell>
      );
    });

  return (
    <Grid
      huge="5"
      tablet="3"
      desktop="4"
      phone="2"
      gutters="extraLarge"
      className={styles.gridStyling}
    >
      {content}
    </Grid>
  );
};
